export default __webpack_public_path__ + "static/media/logo_no_footer.cb9b927e.svg";